import { createContext, useContext, type ReactNode } from 'react';
import { useSelectedEvent } from '@/features/admin/hooks/useSelectedEvent';
import type { EventDto } from '@/shared/types/domain';

interface AdminEventContextValue {
  events: EventDto[];
  eventId: string | null;
  setEventId: (id: string) => void;
  isLoading: boolean;
}

const AdminEventContext = createContext<AdminEventContextValue | null>(null);

export function AdminEventProvider({ children }: { children: ReactNode }) {
  const value = useSelectedEvent();
  return <AdminEventContext.Provider value={value}>{children}</AdminEventContext.Provider>;
}

export function useAdminEvent(): AdminEventContextValue {
  const ctx = useContext(AdminEventContext);
  if (!ctx) throw new Error('useAdminEvent must be used within an AdminEventProvider');
  return ctx;
}
